import React, {Component} from 'react'
import PropTypes from "prop-types"
import {connect} from 'react-redux'
import RenderBody from '../common/RenderBody'
import {IMPORT_EXPORT_QUESTIONS_MODAL, hideModal} from '../../../modules/modals'
import ExportForm from './ExportForm'
import ImportForm from './ImportForm'
import {importId, exportId} from '../../../helpers/importExport'


class ExportModal extends Component {
    render() {
        const {actionType, what, title : _title} = this.props
        if (![importId, exportId].includes(actionType)) return null

        const {formatMessage} = this.context
        const title = _title ?
                    formatMessage(_title) :
                        actionType === importId ?
                            formatMessage('Questions import') :
                            formatMessage('Questions export')

        return (
            <RenderBody
                title = {title}
                handleClose={this.hideModal}
                hideModal={this.hideModal}
                render = {() => {
                    return actionType === importId ?
                                <ImportForm onCancelClick = {this.hideModal} what={what} /> :
                                <ExportForm onCancelClick = {this.hideModal} what={what} />
                }}
            />
        )
    }

    hideModal = () => this.props.hideModal({modalType : IMPORT_EXPORT_QUESTIONS_MODAL})
    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    null,
    {hideModal}
)(ExportModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/ImportExport/index.js